import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { AppDataService } from 'src/app/services/data/app-data.service';
import { AuthService } from '../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { IUser } from '@simplyfly/shared';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { LoaderService } from '../services/loader/loader.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, RouterLink, FaIconComponent, TranslateModule]
})
export class LoginComponent implements OnInit, OnDestroy {
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  form: FormGroup;

  showPassword = false;

  user: IUser;

  private subscriptions = new Subscription();

  constructor(
    private router: Router,
    private authService: AuthService,
    private loaderService: LoaderService
  ) {}

  get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)])
    });
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  loadUserProfile() {
    const authSub = this.authService.currentUser$.subscribe(async user => {
      this.user = user;

      if (this.user) {
        this.router.navigate(['/admin']);
      }
    });
    this.subscriptions.add(authSub);
  }

  submitForm(): void {
    this.form.markAsTouched();

    if (this.form.valid) {
      this.form.disable();

      this.loaderService.presentLoader();

      this.authService
        .signInWithEmailAndPassword(this.form.value.email, this.form.value.password)
        .then(
          async () => {
            await this.loaderService.hideLoaderOnSuccess();

            this.loadUserProfile();
          },
          async err => {
            this.form.enable();

            await this.loaderService.hideLoaderOnFailure(err.message);
          }
        )
        .finally(() => {
          this.form.enable();
        });
    }
  }

  toggleType(): void {
    this.showPassword = !this.showPassword;
  }
}
